import React, { useState, useEffect } from "react";
import { Card, CardContent } from "./Card.jsx";
import axios from "axios";
import { motion } from "framer-motion";
import { Sparklines, SparklinesLine } from "react-sparklines";
import News from "../../assets/bloomberg-logo.jpg";

const indices = [
  { label: "NASDAQ", symbol: "^IXIC" },
  { label: "S&P 500", symbol: "^GSPC" },
  { label: "EUR/USD", symbol: "EURUSD=X" },
  { label: "Taux 10 ans US", symbol: "^TNX" },
  { label: "Gold", symbol: "GC=F" },
  { label: "WTI", symbol: "CL=F" },
];

const Headlines = () => {
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const BACKEND_URL =
  window.location.hostname === "localhost"
    ? process.env.REACT_APP_BACKEND_URL_LOCAL + "/api"
    : process.env.REACT_APP_BACKEND_URL_PROD + "/api";

  const fetchQuotes = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${BACKEND_URL}/headlines`);
      setQuotes(response.data);
    } catch (err) {
      console.error("Erreur chargement des cotations", err);
      setError("Impossible de charger les données de marché.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQuotes();
    const interval = setInterval(fetchQuotes, 300000); // 5 min
    return () => clearInterval(interval);
  }, []);

  const getDataFor = (symbol) => quotes.find((q) => q.symbol === symbol);

  return (
    <Card className="col-span-1 md:col-span-2 lg:col-span-3 bg-[#000000] text-green-400 font-mono rounded-lg shadow-md">
      <CardContent className="p-5">
        <div className="flex justify-between items-center border-b border-gray-700 pb-3 mb-4">
          <div className="text-yellow-400 uppercase text-xs font-bold tracking-widest">
            Bloomberg Terminal — Live Quotes
          </div>
          <img src={News} alt="Bloomberg News" className="h-6 w-auto opacity-60 rounded" />
        </div>

        {error ? (
          <p className="text-red-400">{error}</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {indices.map((index, i) => {
              const data = getDataFor(index.symbol);
              const change = data?.regularMarketChangePercent?.toFixed(2);
              const sparkData = Array.from({ length: 10 }, () =>
                (data?.regularMarketPrice || 0) + (Math.random() - 0.5) * 2
              );

              const color =
                change > 0
                  ? "text-green-400"
                  : change < 0
                  ? "text-red-500"
                  : "text-yellow-300";

              const lineColor = change > 0 ? "#22c55e" : change < 0 ? "#ef4444" : "#eab308";

              return (
                <motion.div
                  key={index.symbol}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: i * 0.1 }}
                  className="bg-[#111111] h-[80px] p-2 rounded-md border border-gray-700 hover:bg-[#1b1b1b] transition duration-200 relative flex flex-col justify-between"
                >
                  <div className="flex justify-between items-start">
                    <div>
                      <div className="text-xs text-yellow-400">{index.label}</div>
                      <div className="text-base font-semibold text-white">
                        {data?.regularMarketPrice?.toLocaleString() || "--"}
                      </div>
                    </div>
                    <div className={`text-xs ${color} mt-0.5`}>
                      {change ? `${change}%` : "--"}
                    </div>
                  </div>

                  {/* Sparkline en bas à droite */}
                  <div className="absolute bottom-1 right-1 w-16 h-4">
                    <Sparklines data={sparkData} limit={10} width={64} height={16}>
                      <SparklinesLine color={lineColor} style={{ fill: "none", strokeWidth: 1.5 }} />
                    </Sparklines>
                  </div>
                </motion.div>
              );
            })}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default Headlines;
